import { parsePublicMapPath } from "./map-share";

export const GOOGLE_ANALYTICS_MEASUREMENT_ID = "G-8HKWVS14P1";

const ANALYTICS_HOSTS = new Set(["tbl.top", "www.tbl.top"]);

export function googleAnalyticsEnabledForHostname(hostname: string) {
  return ANALYTICS_HOSTS.has(hostname.toLowerCase());
}

export function googleAnalyticsEnabledForLocation(hostname: string, pathname: string) {
  return googleAnalyticsEnabledForHostname(hostname) && !parsePublicMapPath(pathname);
}

/** GA honors this route-level kill switch even if a SPA entered a share URL after startup. */
export function syncGoogleAnalyticsRoutePrivacy(pathname = location.pathname) {
  const disabled = Boolean(parsePublicMapPath(pathname));
  (window as typeof window & Record<string, unknown>)[`ga-disable-${GOOGLE_ANALYTICS_MEASUREMENT_ID}`] = disabled;
  return disabled;
}

/** Load Google Analytics only on the public production domain. */
export function initializeGoogleAnalytics(hostname = location.hostname, pathname = location.pathname) {
  if (!googleAnalyticsEnabledForLocation(hostname, pathname) || document.querySelector(`script[data-tbltop-analytics="${GOOGLE_ANALYTICS_MEASUREMENT_ID}"]`)) return false;
  const analyticsWindow = window as typeof window & { dataLayer?: unknown[][]; gtag?: (...args: unknown[]) => void };
  analyticsWindow.dataLayer ??= [];
  analyticsWindow.gtag = (...args: unknown[]) => { analyticsWindow.dataLayer!.push(args); };
  analyticsWindow.gtag("js", new Date());
  analyticsWindow.gtag("config", GOOGLE_ANALYTICS_MEASUREMENT_ID);
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_MEASUREMENT_ID}`;
  script.dataset.tbltopAnalytics = GOOGLE_ANALYTICS_MEASUREMENT_ID;
  document.head.append(script);
  return true;
}
